
import ActivityFormModal from "@/components/projects/activities/ActivityFormModal.vue";

import ActivityDataForModal from '@/entities/modals/ActivityDataForModal';
import RouteNames from '@/entities/RouteNames';
import RouteParams from '@/entities/RouteParams';
import { Project, User, Contractor } from '@/generated/graphql';
import { Vue, Component, Watch, Prop } from 'vue-property-decorator'
import ProjectModal from "@/components/companyProjects/ProjectModal.vue";
import SchedulerCustomModalHeader from "@/components/scheduler/SchedulerCustomModalHeader.vue";
import ProjectViewActivity from "@/entities/scheduler/ProjectViewActivity";
import SchedulerItemEntities from "@/entities/scheduler/SchedulerItemEntities";
import { hslColorFromName } from "@/utils/hslColorFromName";
import initialsHelper from "@/helpers/cardInfoHelperFunctions/initialsHelper";
import CircleWithInitials from "@/components/card/CircleWithInitials.vue";
import S3Image from "@/components/common/s3-image.vue";
import TooltipVariants from "@/entities/TooltipVariants";
import PlusIcon from "@/components/icons/PlusIcon.vue";
import Tooltip from "@/components/common/Tooltip.vue";

interface ContractorChip {
    name: string,
    id: string,
    avatar?: string | null
}

@Component({
    components: {
        ProjectModal,
        SchedulerCustomModalHeader,
        ActivityFormModal,
        CircleWithInitials,
        S3Image,
        PlusIcon,
        Tooltip
    },
})
export default class ProgressItem extends Vue {
    @Prop({ type: Object, default: null }) readonly item!: any;
    @Prop({ type: Object, default: null }) readonly project!: any;

    @Prop({ type: String, default: null }) readonly color!: string;
    @Prop({ type: Number, default: null }) readonly progress!: number;
    @Prop({ type: Number, default: null }) readonly width!: number;
    @Prop({ type: Number, default: null }) readonly marginLeft!: number;
    @Prop({ type: String, default: null }) readonly companyId!: string;
    @Prop({ type: Object, default: null }) readonly currentUser!: any;
    @Prop({ type: String, default: null }) readonly type!: any;
    @Prop({ type: String, default: "h-6 w-6" }) readonly avatarClasses!: string;
    @Prop({ type: Boolean, default: false }) readonly highlightAvatar!: boolean;
    @Prop({ type: Array }) readonly contractors!: Contractor[];
    @Prop({ type: Boolean, default: false }) readonly primary!: boolean;
    @Prop({ type: String, default: undefined }) readonly background?: string;


    modalShown: boolean = false;
    newlyCreatedItemId?: string = undefined;
    showProjectModal = false;
    showActivityModal = false;
    activityInfoForModal?: ActivityDataForModal | null = null;
    projectInfoForModal?: Project | null = null;
    isEdittingLocked: boolean = true;
    TooltipVariants = TooltipVariants;
    routes = RouteNames;


    get getMarginLeftRandom() {
        return 393;
    }
    isSelectedItemManager: boolean = false;

    getRandomewidth(min: number, max: number) {
        return Math.floor(Math.random() * (max - min + 1)) + min;
    }

    get progressPece() {
        return (this.progress / this.width) * 100
    }
    closeModal(): void {
        this.modalShown = false;
        this.isEdittingLocked = true;
        this.showProjectModal = false;
        this.showActivityModal = false;
    }

    handleCloseModal(): void {
        if (this.modalShown == false) {
            return;
        }
        this.clearSelectedItems();
        if (this.newlyCreatedItemId) {
            this.clearNewlyCreatedItemId();
            this.setCurrentlyFetchedItems();
        }
        this.closeModal();
    }

    get shouldBlockEditting(): boolean {
        return this.isEdittingLocked && !Boolean(this.activityInfoForModal?.isNew);
    }

    get bgStyle(): object {
      const colors = this.primary ? "#1A7BEE" : this.background;
      return {
        background: colors ? colors : hslColorFromName(this.initial),
      };
    }
    get initial(): string {
        return initialsHelper(this.item.name ? this.item.name : this.item.title);
    }

    clearSelectedItems(): void {
        const timeline = this.$refs.timeline as any;
        // timeline.setSelection([]);
    }

    async handleCollectionUpdated(): Promise<void> {
        this.clearNewlyCreatedItemId();
        this.clearSelectedItems();
        await this.refetchCollection();
        this.closeModal();
    }

    clearNewlyCreatedItemId(): void {
        this.newlyCreatedItemId = undefined;
    }


    setCurrentlyFetchedItems(): void {
        const timeline = this.$refs.timeline as any;
        // timeline.setItems(this.projectItems);
    }


    refetchCollection(): void {
        this.$emit('refetchCollection');
    }

    get linkToProject(): RouteParams<{ id: string }> {
        return {
            name: RouteNames.PROJECT_ACTIVITY,
            params: { id: this.item?.id || "" }
        }
    }

    handleEditClick(): void {
        this.isEdittingLocked = false;
    }

    handleProgresBarClick(): void {
        if (this.type == 'project') {
            this.showProjectModal = true;
            this.projectInfoForModal = this.item;
            this.modalShown = true;
        }

        if (this.type == 'activity') {
            this.showActivityModal = true;
            this.activityInfoForModal = this.item;
            this.projectInfoForModal = this.project;
            this.modalShown = true;
        }
    }

    get linkToProjectActivities(): RouteParams<{ id: string }> {
        return {
            name: RouteNames.PROJECT_ACTIVITY,
            params: { id: this.item?.id || "" }
        }
    }

    get remainingWidth(): number {
        if (!this.progress) {
            return 100;
        }
        return 100 - this.progress;
    }

    get innerMarginLeft(): number {
        if (!this.progress || !this.width) {
            return 0;
        }
        return this.width * (this.progress / 100);
    }
    get avatarStyleClasses(): Record<string, boolean> {
        return {
            [this.avatarClasses]: Boolean(this.avatarClasses),
            ["border border-primary"]: this.highlightAvatar,
        };
    }
    get defaultImageClasses(): string {
        return "inline-block rounded-full object-cover object-center";
    }
    get defaultInitialsClasses(): string {
        return "inline-flex h-6 w-6 rounded-full items-center justify-center";
    }
    get contractor(): ContractorChip {
        const contractor = this.item.project_activities?.contractor;
        const user = contractor.user;
        const contractorId = contractor.id;

        return {
            name: `${user.given_name} ${user.family_name}`,
            avatar: user.avatar,
            id: contractorId,
        };
    }
    get contractorExists(): boolean {
        return Boolean(this.item.project_activities?.contractor?.user);
    }


    getContractorFullname(user: User): string {
        if (!user) {
            return "";
        }
        if (!user?.given_name && user?.family_name) {
            return user?.family_name;
        }
        if (user?.given_name && !user?.family_name) {
            return user?.given_name;
        }
        if (!user?.given_name && !user?.family_name) {
            return "";
        }
        return user?.given_name + " " + user?.family_name;
    }

}
